import React from 'react';
import classnames from 'classnames';

import { ContextProvider } from '@/context';
import Header from '@/sections/Layout/Header';
import Footer from '@/sections/Layout/Footer';
import GetCirrusoftModalWithContext from '@/components/Modals/GetCirrusoft/modalWithContext';

import footerData from '@/mocks/footerData';

const Layout = ({
  children,
  currentPageClass,
  headerClass,
  mainClass,
  footerClass,
}) => {
  return (
    <ContextProvider>
      <div className={classnames(currentPageClass, 'cr-page-wrapper')}>
        <Header className={headerClass} />
        <main className={mainClass}>{children()}</main>
        <Footer className={footerClass} footerData={footerData} />

        <GetCirrusoftModalWithContext />
      </div>
    </ContextProvider>
  );
};

export default Layout;
